import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CoursesService } from '@draeger-academy/common';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { Course } from 'models/course';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'da-tab-section',
    templateUrl: './tab-section.component.html',
    styleUrls: ['./tab-section.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabSectionComponent implements OnInit {
    @Input() data;
    @Input() site;
    public course: Course = null;

    public description: any;
    public url: string;
    public showEventTab: boolean;
    public language: boolean;

    private _$showDownload: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showDownload$(): Observable<boolean> {
        return this._$showDownload.asObservable();
    }

    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        private _configurationService: ConfigurationService,
        private _courseService: CoursesService
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.course = new Course(this.data);
            if (this.course && this.course.events && this.course.events.length > 0) {
                this.showEventTab = true;
            } else {
                this.showEventTab = false;
            }
        }
        this.setCourseDescription();
        this._courseService.languageSelected.subscribe((language) => {
            this.setCourseDescription();
        });

        this._$showDownload.next(this._configurationService.hasFeature('DownloadCourseDescription'));

        if (this.course && this.course.id) {
            this.url = `${environment.APIEndpoint}api/v1/course/getcoursedescription/${this.course.id}`;
        }
    }

    private setCourseDescription() {
        if (this.course && this.course.training && this.course.training.description) {
            this.description = this.course.training.trainingDescriptions;
        }

        const site = this._configurationService.getSiteFromUrl();
        if (site) {
            this.site = site.site;
            this.language = this.site.split('_')[0];
        }
        if (this._configurationService.isPartnerPage()) {
            this.language = JSON.parse(sessionStorage.getItem('portalLang'))?.lang;
            this.site = JSON.parse(sessionStorage.getItem('portalLang'))?.portalId;
        }
        const newDescription = [];

        if (this.description && this.description.length > 0) {
            for (const desc of this.description) {
                if (desc.languageKey === this.language) {
                    newDescription.push(desc);
                }
            }
            if (newDescription.length === 0) {
                for (const desc of this.description) {
                    if (desc.languageKey === this.course.language) {
                        newDescription.push(desc);
                    }
                }
            }

            this.description = newDescription;
        }
    }
}
